// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-display-container {
  height: 100%;
  aspect-ratio: 1;
  box-sizing: border-box;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  cursor: grab;
}

.avatar-display-container:active {
  cursor: grabbing;
}

.avatar-display-container canvas {
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/avatar-display/AvatarDisplay.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".avatar-display-container {\n  height: 100%;\n  aspect-ratio: 1;\n  box-sizing: border-box;\n  border: 1px solid var(--border-color);\n  border-radius: 50%;\n  cursor: grab;\n}\n\n.avatar-display-container:active {\n  cursor: grabbing;\n}\n\n.avatar-display-container canvas {\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
